import { createFileRoute } from '@tanstack/react-router';
import { ProtectedRoute } from '@org/ui';
import { GrammarVideosList } from '../app/components/grammar/grammar-videos-list';

export const Route = createFileRoute('/grammar-videos')({
  component: GrammarVideosRoute,
});

function GrammarVideosRoute() {
  return (
    <ProtectedRoute requiredPermissions={['admin:all']}>
      <GrammarVideosList />
    </ProtectedRoute>
  );
}
